import { ClipboardList, FileText, Hammer, MessageSquare } from "lucide-react";

const STEPS = [
  { icon: ClipboardList, title: "Free estimate", text: "Tell us about your home or concrete job. We visit, measure and send a clear, itemized estimate." },
  { icon: FileText, title: "Approve online", text: "Review and approve your estimate right from your customer portal — no paper chasing." },
  { icon: Hammer, title: "We build", text: "Our crew gets to work. Milestones and progress updates are posted as the job moves." },
  { icon: MessageSquare, title: "Stay in the loop", text: "Message the team, see updates and pay invoices online, any time." },
];

export const About = () => (
  <section id="about" className="relative overflow-hidden bg-[#0E1F3F] py-16 text-white sm:py-24 lg:py-28">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <p className="eyebrow mb-3 !text-[#F2B91C]">Matthew 7:24 · Build upon the rock</p>
        <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">A builder that keeps you informed — from first call to final pour.</h2>
        <p className="mt-6 leading-relaxed text-white/70">
          Based in Lucerne Valley, Firm Foundations Construction serves homeowners across the High Desert and surrounding areas. Every customer gets their own online portal for estimates, invoices and constant project updates.
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
        {STEPS.map((s, i) => (
          <div key={s.title} data-testid={`process-step-${i}`} className="rounded-xl border border-white/10 bg-white/[0.04] p-6 transition-colors hover:border-[#F2B91C]/60">
            <div className="mb-4 flex items-center justify-between">
              <s.icon className="text-[#F2B91C]" size={22} />
              <span className="font-mono-num text-xs text-white/40">0{i + 1}</span>
            </div>
            <h3 className="font-display text-xl font-semibold">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/65">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
